import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_LIST_PAGE_SIZE } from './constants';
import useBrands from './hooks/useBrands';
import PageHeader from './components/PageHeader';
import Pagination from './components/Pagination';
import BrandDisplayCard from './components/BrandDisplayCard';
import type { BrandRecord } from './types/index';

export default function BrandsPage({ onAdd, onEdit, organizationId, currentUser }) {

  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [paginationOrganizationId, setPaginationOrganizationId] = useState(organizationId);
  const pageSize = DEFAULT_LIST_PAGE_SIZE;

  if (paginationOrganizationId !== organizationId) {
    setPaginationOrganizationId(organizationId);
    setPage(0);
  }

  const { data, total } = useBrands({ organizationId, page, pageSize });


  return (
    <div className="stack" data-testid="page-brands">
      <button className="button" type="button" onClick={() => navigate('/admin')} data-testid="brands-back-to-admin" style={{ alignSelf: 'flex-start' }}>
        Back
      </button>
      <PageHeader
        title="Brands"
        subtitle="Brand Directory"
        actions={
          <div>
          {(currentUser?.roleActions?.indexOf('WriteBrands') >= 0 ||
            currentUser?.roleActions?.indexOf('AdminBrands') >= 0) && <button className="button cta" onClick={onAdd} data-testid="brands-add">
            <span className="plus" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.33301 8H12.6663" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8 3.33301V12.6663" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            Add Brand
          </button>}
          </div>
        }
      />
      <div className="brand-grid" data-testid="brands-grid">
        {data.map((b: BrandRecord) => (
          <BrandDisplayCard key={b.id} brand={b} onEdit={onEdit} currentUser={currentUser} />
        ))}
      </div>

      <div data-testid="brands-pagination">
        <Pagination
          page={page}
          totalPages={Math.ceil(total / pageSize)}
          onPrev={() => { setPage((current) => current - 1) }}
          onNext={() => { setPage((current) => current + 1) }}
          format="of"
          prevLabel="◀"
          nextLabel="▶"
        />
      </div>
    </div>
  );
}
